var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        style:
          "font-size: " +
          _vm.font_size +
          "%;font-family: tahoma;color: black;float: left;width: 100%;padding: 0 15px 0 15px;"
      },
      [
        _vm.shop_logo
          ? _c(
              "div",
              {
                staticStyle: { "text-align": "center", "margin-bottom": "5px" }
              },
              [
                _c("img", {
                  staticStyle: {
                    width: "10.583333333mm",
                    height: "10.583333333mm"
                  },
                  attrs: { src: _vm.shop_logo }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.shop_tax_title && _vm.shop_tax_id
          ? _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "0.625em",
                  "line-height": "1.2em",
                  "margin-bottom": ".75em"
                }
              },
              [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("apps.pos.message.taxtitle")))
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "center",
              "font-size": "0.7em",
              "line-height": "1.2em"
            }
          },
          [_c("strong", [_vm._v(_vm._s(_vm.shop_name))])]
        ),
        _vm._v(" "),
        _vm.shop_address
          ? _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "0.5em",
                  "line-height": "1.5em"
                }
              },
              [
                _c("span", [
                  _vm._v("\n        " + _vm._s(_vm.shop_address) + "\n      ")
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.shop_tax_id
          ? _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "0.5em",
                  "line-height": "1.5em"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.taxid")) +
                      ": " +
                      _vm._s(_vm.shop_tax_id) +
                      "\n      "
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.shop_tel
          ? _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "0.5em",
                  "line-height": "1.5em"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.tel")) +
                      ": " +
                      _vm._s(_vm.shop_tel) +
                      "\n      "
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticStyle: {
              padding: "0",
              margin: "3mm 0 1mm 0",
              float: "left",
              width: "100%"
            }
          },
          _vm._l(_vm.filterOrder, function(order, index) {
            return _c(
              "li",
              {
                key: index,
                staticStyle: {
                  "list-style": "none",
                  "border-bottom": "1px black dotted",
                  "margin-bottom": "5px",
                  float: "left",
                  width: "100%"
                }
              },
              [
                _c(
                  "p",
                  { staticStyle: { margin: "0", "font-size": "0.5em" } },
                  [
                    _c("span", [
                      _vm._v(
                        "\n            " + _vm._s(order.item) + "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { float: "right" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getNumber(order.price)) +
                          "\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(order.modifiers, function(modifier, index_) {
                  return _c(
                    "span",
                    { key: index_ },
                    _vm._l(modifier.options, function(modifieroption, index__) {
                      return _c(
                        "p",
                        {
                          key: index__,
                          staticStyle: { margin: "0", "font-size": "0.5em" }
                        },
                        [
                          _vm._v(
                            "\n            + " +
                              _vm._s(modifieroption.option) +
                              "\n            "
                          ),
                          _c("span", { staticStyle: { float: "right" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.getNumber(modifieroption.price)) +
                                "\n            "
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                }),
                _vm._v(" "),
                order.discount > 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          float: "left",
                          width: "100%",
                          "margin-top": "0px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { margin: "0", "font-size": "0.5em" }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("message.discount")) +
                                "\n            "
                            ),
                            _c("span", { staticStyle: { float: "right" } }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getNumber(order.discount)) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      float: "left",
                      width: "100%",
                      "margin-top": "0",
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "baseline"
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticStyle: { margin: "0", "font-size": "0.5em" } },
                      [
                        _vm._v(
                          "\n            x" +
                            _vm._s(order.quantity) +
                            " " +
                            _vm._s(order.unit) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { float: "right", "font-size": "0.5em" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getNumber(order.total)) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.total_price.discount
          ? _c("div", { staticStyle: { float: "left", width: "100%" } }, [
              _c(
                "span",
                { staticStyle: { "font-size": "0.5em", float: "left" } },
                [_vm._v(_vm._s(_vm.$t("message.discounts")))]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    margin: "0",
                    "font-size": "0.5em",
                    float: "right"
                  }
                },
                [_vm._v(_vm._s(_vm.getNumber(_vm.total_price.discount)))]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.taxes, function(tax, index) {
          return _c(
            "div",
            { key: index, staticStyle: { float: "left", width: "100%" } },
            [
              _c(
                "span",
                { staticStyle: { "font-size": "0.5em", float: "left" } },
                [_vm._v("\n        " + _vm._s(tax.displayText) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    margin: "0",
                    "font-size": "0.5em",
                    float: "right"
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.getNumber(tax.total)) + "\n      "
                  )
                ]
              )
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticStyle: { float: "left", width: "100%" } }, [
          _c("span", { staticStyle: { "font-size": "0.5em", float: "left" } }, [
            _vm._v(_vm._s(_vm.$t("message.total")))
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: { margin: "0", "font-size": "0.5em", float: "right" }
            },
            [_vm._v(_vm._s(_vm.getNumber(_vm.total_price.total)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { float: "left", width: "100%" } }, [
          _c("span", { staticStyle: { "font-size": "0.5em", float: "left" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("apps.pos.message." + _vm.receipt_info.paymentMethod)
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: { margin: "0", "font-size": "0.5em", float: "right" }
            },
            [_vm._v(_vm._s(_vm.getNumber(_vm.receipt_info.paid)))]
          )
        ]),
        _vm._v(" "),
        _vm.receipt_info.paymentMethod === _vm.POS_PAYMENT_METHOD.CASH
          ? _c("div", { staticStyle: { float: "left", width: "100%" } }, [
              _c(
                "span",
                { staticStyle: { "font-size": "0.5em", float: "left" } },
                [_vm._v(_vm._s(_vm.$t("message.changecash", { number: null })))]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    margin: "0",
                    "font-size": "0.5em",
                    float: "right"
                  }
                },
                [_vm._v(_vm._s(_vm.getNumber(_vm.receipt_info.change)))]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "footer",
            staticStyle: {
              "border-top": "dotted 1px #000",
              "padding-top": "10px",
              margin: "5px 0 0 0",
              float: "left",
              width: "100%",
              "text-align": "center"
            }
          },
          [
            _c("p", { staticClass: "m-0" }, [
              _vm.receipt_info.bi_code
                ? _c(
                    "strong",
                    {
                      staticStyle: {
                        "font-size": "0.7em",
                        "line-height": "1.5em"
                      }
                    },
                    [
                      _vm._v(
                        "\n          #" +
                          _vm._s(_vm.receipt_info.bi_code) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.receipt_info.customer
                ? _c(
                    "strong",
                    {
                      staticStyle: {
                        "font-size": "0.7em",
                        "line-height": "1.5em"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.receipt_info.customer.customer_name) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.text_footer
              ? _c(
                  "p",
                  {
                    staticClass: "m-0",
                    staticStyle: {
                      "font-size": "0.5em",
                      "line-height": "1.5em"
                    }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.text_footer) + "\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "m-0",
                staticStyle: { "font-size": "0.5em", "line-height": "1.5em" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.receipt_info.ps_code) +
                    "\n        " +
                    _vm._s(_vm.date_time) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "m-0",
                staticStyle: { "font-size": "0.5em", "line-height": "1.5em" }
              },
              [_vm._v("\n        By TreeSoft.io\n      ")]
            )
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fa1f36d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa1f36d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/print/pos/Receipt.vue
// module id = null
// module chunks = 